var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 1.99996,
    height: 0.999979,
    fill: "#232323"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 5.99976,
    width: 0.999979,
    height: 0.999979,
    fill: "#232323"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 4.99976,
    width: 0.999979,
    height: 0.999979,
    fill: "#232323"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.0005,
    y: 3.99976,
    width: 0.999979,
    height: 0.999979,
    fill: "#232323"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 3,
    width: 0.999979,
    height: 0.999979,
    fill: "#232323"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9995,
    y: 2,
    width: 0.999979,
    height: 0.999979,
    fill: "#232323"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9995,
    y: 1,
    width: 0.999979,
    height: 0.999979,
    fill: "#232323"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 1,
    width: 0.999979,
    height: 10.9998,
    fill: "#232323"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 0.999979,
    height: 0.999979,
    transform: "matrix(-1 0 0 1 7 5.99976)",
    fill: "#232323"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 0.999979,
    height: 0.999979,
    transform: "matrix(-1 0 0 1 6 4.99976)",
    fill: "#232323"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 0.999979,
    height: 0.999979,
    transform: "matrix(-1 0 0 1 5 3.99976)",
    fill: "#232323"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 0.999979,
    height: 0.999979,
    transform: "matrix(-1 0 0 1 4.00049 3)",
    fill: "#232323"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 0.999979,
    height: 0.999979,
    transform: "matrix(-1 0 0 1 3.00049 2)",
    fill: "#232323"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 0.999979,
    height: 0.999979,
    transform: "matrix(-1 0 0 1 1.99951 1)",
    fill: "#232323"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9995,
    y: 11.9998,
    width: 0.999979,
    height: 0.999979,
    fill: "#232323"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 0.999979,
    height: 0.999979,
    transform: "matrix(-1 0 0 1 1.99951 11.9998)",
    fill: "#232323"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 0.999979,
    height: 10.9998,
    transform: "matrix(-1 0 0 1 1 1)",
    fill: "#232323"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 13.9997,
    height: 0.999979,
    fill: "#232323"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1.99951,
    y: 12.9998,
    width: 11.9997,
    height: 0.999979,
    fill: "#232323"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.27e0b52ba53d05764c5ffe0d5f5d73ba.svg";
export { ForwardRef as ReactComponent };